/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router';
// material
import { Division, InContentMessage, Content, LoadState, PrivateRoute } from '@insticator/insticator-ui'; // iui-material
// pages
import CommentingAnalyticsPage from './commentinganalytics/commentinganalytics'
import CommentImporterTool from './commentimportertool/commentimportertool';
import ImportPreview from './commentimportertool/importpreview/importpreview';
import CommentingCodePage from './code/code';
import CommentingAdvancedPage from './commentingadvanced/commentingadvanced';
import CommentingConfigPage from './commentingconfig/commentingconfig';
import RequestCommentWidget from './commentingconfig/requestcommentwidget/requestcommentwidget';
// utils

// thunks

// styles
import injectSheet from 'react-jss';
import styles from './commenting_styles';
import CommentingConfigV2Page from './commentingconfigv2/commentingconfigv2';
import { PRODUCT_COMMENTING, PRODUCT_COMMENTING_V2 } from 'state/thunks/account';



/* ========== ~~~~~~~~~~ COMMENTING DIVISION ~~~~~~~~~~ ========== */

export default injectSheet(styles)((props) => {
  const { mocked, userEmail, mockupGenerator, siteUUID } = useSelector(state => state.session);
  const { accountProductsReceived, accountProducts, accountProductRequestStatus } = useSelector(state => state.account);
  const { commentingAccessRequest} = useSelector(state => state.commenting)
  const { isMigrationUpdating, sitesWithProductsV2 } = useSelector(state => state.migrationStatus)
  const isInsticatorUser = mocked || /@insticator.com\s*$/.test(userEmail)
  // To ensure only v1 or v2 config is loaded once. 
  // Sometimes there's instance of COMMENTING_V2 and COMMENTING on account products
  const hasCommentingV2 = (accountProducts.includes(PRODUCT_COMMENTING_V2) && !accountProducts.includes(PRODUCT_COMMENTING)) || sitesWithProductsV2.includes(siteUUID)
  const hasCommenting = accountProducts.includes(PRODUCT_COMMENTING) || accountProducts.includes(PRODUCT_COMMENTING_V2)

  const permittedToRequest = !hasCommenting && accountProductsReceived;
  const permittedToConfig = hasCommenting && accountProductsReceived

  const _getPermittedPath = useCallback(() => {
    // in here we will check if user has been approved from commenting yet
    // if (mockupGenerator) return `/dashboard/commenting/${hasCommenting ? 'configuration' : 'requestaccess'}`;
    if (accountProductRequestStatus === 'failed' || !accountProductsReceived) {
      return `/error/403`;
    }
    if (hasCommenting || isMigrationUpdating) {
      return '/dashboard/commenting/configuration'
    }
    return '/dashboard/productmanager'
  }, [hasCommenting, isMigrationUpdating])

  return (
    <Division name={`commenting`} klass={props.classes.commenting}>
      <Switch>
        {/*Routes to subdivisions*/}
        <Route exact path='/dashboard/commenting' render={() => <Redirect to={'dashboard/commenting/analytics'} />} />
        <Route path='/dashboard/commenting/analytics' component={CommentingAnalyticsPage} />
        <PrivateRoute permitted={permittedToConfig} redirectTo={_getPermittedPath()} path='/dashboard/commenting/code' component={CommentingCodePage} />
        <PrivateRoute permitted={permittedToRequest} redirectTo={_getPermittedPath()} path={'/dashboard/commenting/requestaccess'} component={RequestCommentWidget} />
        <PrivateRoute permitted={permittedToConfig} redirectTo={_getPermittedPath()} path={'/dashboard/commenting/configuration'} component={CommentingConfigV2Page} />
        <PrivateRoute permitted={permittedToConfig} redirectTo={_getPermittedPath()} path='/dashboard/commenting/advanced' component={CommentingAdvancedPage} />
        <Route path='/dashboard/commenting/importertool' render={() => isInsticatorUser ? <CommentImporterTool /> : <Redirect to={'/error/403'} />} />
        <Route path='/dashboard/commenting/import/preview/:integrationId' render={(props) => isInsticatorUser ? <ImportPreview {...props} /> : <Redirect to={'/error/403'} />} />
        <Redirect to='/error/404' />
      </Switch>
    </Division>
  )
})